import { Component, Input, ViewChild } from "@angular/core";
import { ColumnChartOptions } from "../../services/chart-helper.service"

@Component({
  selector: 'app-lcv-ev-column-chart',
  templateUrl: './lcv-ev-column-chart.component.html',
  styleUrls: ['./lcv-ev-column-chart.component.scss']
})
export class LcvEvColumnChartComponent {  
  // @Input() evData: IGraphEv | null = null;
  
  @Input() year: number = 0;
  @Input() selectedToggle: string = '';
  @Input() chartOptions: ColumnChartOptions | null = null
}
